import { SimpleAutocompleteResult } from "../../../components/autocomplete/types";
// import { FileInputDeleteSuccess, FileInputUploadSuccess } from "../../../components/fields/types";
import { defaultUploadFileSettings } from "../../../components/fileFields";
import Upload from 'adeliom-upload-js';
import { City, storeLocatorAutocomplete } from "../../helpers/storeLocator";
import { isPhoneInputValid, getPhonePrefixStore } from './phonePrefixComponent';

function initFieldsComponent() {
    const initFieldsLogic = {
        // Chars gestion
        nbOfCharsState: 0,
        maxCharsLastNameState: 150,
        maxCharsFirstNameState: 150,
        maxCharsEmailState: 150,
        maxCharsAddressState: 300,
        maxCharsTextareaState: 1500,
        // Validation
        submitDisabledState: true,
        civilityValid: false,
        lastNameValid: false,
        firstNameValid: false,
        emailValid: false,
        telValid: false,
        addressValid: false,
        // Autocomplete
        results: [],
        nbInputs: null as number | null,
        displayResultsWording: false,
        noResults: false,
        tooShort: false,
        tooLong: false,
        modal: false,
        disabled: false,
        // Checkmarks
        lastNameCheckValidState: undefined as boolean | undefined,
        firstNameCheckValidState: undefined as boolean | undefined,
        emailCheckValidState: undefined as boolean | undefined,
        phoneCheckValidState: undefined as boolean | undefined,
        zipCheckValidState: undefined as boolean | undefined,
        cityCheckValidState: undefined as boolean | undefined,
        // url: window.location.origin + '/api/insee/',
        initInputFileFct() {
            const uploadField = new Upload({
                ...defaultUploadFileSettings,
                ...{
                    selector: '.input-test'
                }
            });
            uploadField.init();
        },
        validateLastStepFct(item: string) {
            const civility = document.querySelectorAll('[name="civility"]:checked') as NodeListOf<HTMLInputElement>;

            if (civility.length) {
                this.civilityValid = true
            }

            //Vérification lastName
            if (item == 'lastname') {
                const lastname = document.querySelector('[name="lastname"]') as HTMLInputElement;
                const inputSpanLastName: any = lastname.parentElement?.parentElement?.querySelector('span')
                let lastNameError = '';
                if (lastname.value === '') {
                    lastNameError = 'Ce champ est requis.'
                } else if (/\d/.test(lastname.value)) {
                    lastNameError = 'Ce champ ne doit pas contenir de chiffre.'
                } else if (lastname.value.length > 150) {
                    lastNameError = '150 caractères maximum.'
                }
                this.lastNameValid = lastNameError === ''
                this.lastNameCheckValidState = lastNameError === ''
                if (inputSpanLastName) inputSpanLastName.innerHTML = lastNameError
            }

            if (item == 'firstname') {
                //Vérification firstName
                const firstname = document.querySelector('[name="firstname"]') as HTMLInputElement;
                const inputSpanFirstName: any = firstname.parentElement?.parentElement?.querySelector('span')
                let firstNameError = '';
                if (firstname.value.length === 0) {
                    firstNameError = 'Ce champ est requis.'
                } else if (/\d/.test(firstname.value)) {
                    firstNameError = 'Ce champ ne doit pas contenir de chiffre.'
                } else if (firstname.value.length > 150) {
                    firstNameError = '150 caractères maximum.'
                }
                this.firstNameValid = firstNameError === ''
                this.firstNameCheckValidState = firstNameError === ''
                if (inputSpanFirstName) inputSpanFirstName.innerHTML = firstNameError
            }

            if (item == 'email') {
                //Vérification email
                const email = document.querySelector('[name="email"]') as HTMLInputElement;
                const inputSpanEmail: any = email.parentElement?.parentElement?.querySelector('span')
                const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                email.addEventListener("blur", () => {
                    const isValid = email.value.trim() !== '' && emailPattern.test(email.value) && email.value.length <= 150;
                    this.emailValid = isValid;
                    this.emailCheckValidState = isValid;
                    if (inputSpanEmail) {
                        inputSpanEmail.innerHTML = isValid ? '' : email.value.length > 150 ? '150 caractères maximum.' : 'Ce champ n\'est pas complet ou erroné.'
                    }
                });

                const isValid = email.value.trim() !== '' && emailPattern.test(email.value) && email.value.length <= 150;
                this.emailValid = isValid;
                this.emailCheckValidState = isValid;
                if (inputSpanEmail) {
                    inputSpanEmail.innerHTML = isValid ? '' : email.value.length > 150 ? '150 caractères maximum.' : 'Ce champ n\'est pas complet ou erroné.'
                }
            }

            if (item == 'tel') {
                const phone = document.querySelector('[name="phone"]') as HTMLInputElement;
                const inputSpanTel = phone.parentElement?.parentElement?.querySelector('span.text-alert-danger') as HTMLSpanElement | null;
                const store = getPhonePrefixStore();
                const result = isPhoneInputValid(phone.value, store?.enabled ?? false, store?.country ?? null);
                this.telValid = result.valid;
                this.phoneCheckValidState = result.valid;
                if (inputSpanTel) {
                    inputSpanTel.innerHTML = result.valid ? '' : result.message;
                }

                // Silently re-check email in case its blur event was missed (e.g. headless browser)
                const emailEl = document.querySelector('[name="email"]') as HTMLInputElement;
                if (emailEl && emailEl.value.trim() !== '') {
                    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (emailPattern.test(emailEl.value) && emailEl.value.length <= 150) {
                        this.emailValid = true;
                    }
                }
            }

            if (item == 'zip') {
                const zipCode = document.querySelector('[name="zip-code[zip]"]') as HTMLInputElement;
                const inputSpanZipCode: any = zipCode.parentElement?.parentElement?.querySelector('span')
                let valueIsCorrect = false;
                // setTimeout parce qu'au blur l'input value n'est pas remplacée
                setTimeout(() => {
                // Si le champ est vide
                if ((zipCode && zipCode.value == '') && inputSpanZipCode) {
                    inputSpanZipCode.innerHTML = 'Ce champ est requis.'
                    this.zipCheckValidState = false
                } else {
                    // Test si la value de l'input est correct
                   // setTimeout(() => {
                        const allResult = this.results = JSON.parse(JSON.stringify(this.results));
                        // Récupérer les resultats de l'api et Rechercher si la value est égale à un des resultats
                        allResult.forEach(el => {
                            // Si il y a plusieurs code postaux ex Strasbourg 67000 67100 67200
                            if (el.codesPostaux.length > 1)
                                el.codesPostaux.forEach(subEl => {
                                    const result = subEl + ' ' + el.nom
                                    if (zipCode && zipCode.value == result) {
                                        valueIsCorrect = true;
                                    }
                                })
                            else {
                                const result = el.codesPostaux[0] + ' ' + el.nom
                                if (zipCode && zipCode.value == result) {
                                    valueIsCorrect = true;
                                }
                            }
                        });
                        // Si input.value = un des resultats
                        if (valueIsCorrect && inputSpanZipCode) {
                            inputSpanZipCode.innerHTML = ''
                            this.zipCheckValidState = true
                            this.addressValid = true
                        } else if (inputSpanZipCode) {
                            inputSpanZipCode.innerHTML = 'Ce champ n’est pas complet ou erroné'
                            this.zipCheckValidState = false
                            this.addressValid = false
                        }
                }
            }, 200)
            }
            // Timeout pour executer la valdation après le zip
            // Use Alpine.$data on the root element to avoid nested x-data scope isolation
            // (this = mergeProxies([innerData_field, rootData]) — SET may not reach rootData)
            setTimeout(() => {
                const zipFieldExists = !!document.querySelector('[name="zip-code[zip]"]');
                const zipValid = !zipFieldExists || !!this.zipCheckValidState;
                const allValid = this.civilityValid && this.lastNameValid && this.firstNameValid && this.telValid && this.emailValid && zipValid;
                const formEl = document.querySelector<HTMLElement>('[x-data*="initTunnels"]');
                const AlpineInstance = (window as any).AlpineTryba;
                if (formEl && AlpineInstance?.$data) {
                    AlpineInstance.$data(formEl).submitDisabledState = !allValid;
                } else {
                    this.submitDisabledState = !allValid;
                }
            }, 200)
        },
        lengthLimitFct(maxLength: number, item: any, event: KeyboardEvent & { target: HTMLInputElement }) {
            let wrapper: any = null;
            if (item.parentElement.querySelector('#lengthControl')) {
                wrapper = item.parentElement.querySelector('#lengthControl')
            } else {
                wrapper = item.parentElement.parentElement.querySelector('#lengthControl')
            }

            if (event.target.value.length === maxLength) {
                if (wrapper.classList.contains('text-secondary-02')) {
                    return;
                } else {
                    wrapper.classList.add('text-secondary-02')
                }
            } else {
                if (wrapper.classList.contains('text-secondary-02')) {
                    wrapper.classList.remove('text-secondary-02')
                }
            }
            wrapper.innerHTML = event.target.value.length + '/' + maxLength
        },
        // Autocomplete
        validateInputFct(event: any) {
            const targetValue = event.target.value.trim();
            if (targetValue !== '' && event.keyCode !== 13 ) {
                this.nbInputs = targetValue.length;
                this.modal = true;
                this.tooLong = false;
                this.zipCheckValidState = undefined

                if (!isNaN(targetValue)) {
                    if (this.nbInputs == 0) {
                        this.disabled = true;
                    }
                    if (this.nbInputs && this.nbInputs > 5) {
                        this.noResults = false;
                        this.tooLong = true;
                        this.zipCheckValidState = false
                        return;
                    }
                }

                storeLocatorAutocomplete(targetValue)
                    .then((cities) => {
                        (this.results as Array<City>) = cities;
                    })
                    .then(() => {
                        this.displayResultsFct();
                    })
                    .catch((error) => {
                        console.error("Error fetching autocomplete results:", error);
                        this.results = [];
                        this.displayResultsWording = false;
                        this.noResults = true;
                    });
            }
        },
        validateLengthFct(event: KeyboardEvent & { target: HTMLInputElement }, isMobile: boolean) {
            this.nbInputs = event.target.value.length;
            this.nbOfCharsState = this.nbInputs

            if (isMobile) {
                event.target.style.height = "98px";

            } else {
                event.target.style.height = "82px";
            }
        },
        displayResultsFct() {
            this.results = JSON.parse(JSON.stringify(this.results));
            this.modal = true;
            if (this.results.length) {
                this.tooLong = false;
                this.tooShort = false;
                this.noResults = false;
                this.displayResultsWording = true;
            } else {
                //No results
                if (this.nbInputs && this.nbInputs >= 1) {
                    this.noResults = true;
                    this.tooShort = false;
                    this.tooLong = false;
                }

                this.displayResultsWording = false;
            }
        },
        openModalFct() {
            this.modal = true;
            this.displayResultsFct();
        },
        closeModalFct() {
            this.modal = false;
        },
        setCityInBasicFormFct(selectedItem: SimpleAutocompleteResult, domItem: HTMLElement, index = 0) {
            try {
                const actualForm = domItem.closest('form')
                if(actualForm) {
                    const zipInput = actualForm.querySelector<HTMLInputElement>('[name$="[zip]"]');
                    if (zipInput) {
                        zipInput.value = selectedItem.codesPostaux[index] + ' ' + selectedItem.nom;
                    }
                    this.zipCheckValidState = true
                    this.cityCheckValidState = true
                }
            } catch (e) {
                this.zipCheckValidState = false
                this.cityCheckValidState = false
            }
            // this.closeModalFct();
        },
    };

    return initFieldsLogic;
}

export default initFieldsComponent();
